import React from 'react';

import { SIGNAL_LABELS } from './fleetRules';

/** Pastille « Signal actif / Sans signal » : le seul endroit qui écrit ces mots. */
export default function SignalBadge({ actif, className = '' }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${
        actif ? 'bg-success/15 text-success' : 'bg-muted text-muted-foreground'
      } ${className}`}
    >
      <span
        className={`h-2 w-2 rounded-full ${actif ? 'bg-success' : 'border-2 border-destructive'}`}
        aria-hidden="true"
      />
      {actif ? SIGNAL_LABELS.on : SIGNAL_LABELS.off}
    </span>
  );
}
